<template>
  <el-submenu v-if="menuItem.children && menuItem.children.length >= 1" :index="menuItem.id.toString()">
    <template slot="title">
      <i :class="menuItem.menuIcon"></i>
      <span slot="title">{{menuItem.menuname}}</span>
    </template>
    <MenuItem v-for="childMenuItem in menuItem.children" :key="childMenuItem.id" :menuItem="childMenuItem"/>
  </el-submenu>
  <el-menu-item v-else :index="menuItem.id +''" @click="handleRoute(menuItem.menuurl)">
    <i :class="menuItem.menuIcon"></i>
    <span slot="title">{{menuItem.menuname}}</span>
  </el-menu-item>
</template>

<script>
export default {
  name: "MenuItem",
  props: {
    menuItem: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleRoute(menuUrl) {
      if (menuUrl != null && this.$route.path!= menuUrl) {
        this.$router.push(menuUrl);
      }
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/layout/navmenu/navmenuitem.vue